//export const baseUrl = "http://localhost:30200";
export const baseUrl = "https://api.eeshop.ba";
